<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2035_33348)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9993 2C9.64387 2.00012 8.30814 2.32436 7.10353 2.94569C5.89893 3.56702 4.86037 4.46742 4.07451 5.57175C3.28866 6.67609 2.77829 7.95235 2.58599 9.29404C2.39368 10.6357 2.52503 12.004 2.96906 13.2846C3.41308 14.5652 4.15692 15.7211 5.13851 16.6557C6.1201 17.5904 7.31098 18.2768 8.61179 18.6576C9.9126 19.0384 11.2856 19.1026 12.6163 18.8449C13.947 18.5872 15.1967 18.015 16.2613 17.176L19.9133 20.828C20.1019 21.0102 20.3545 21.111 20.6167 21.1087C20.8789 21.1064 21.1297 21.0012 21.3151 20.8158C21.5005 20.6304 21.6057 20.3796 21.608 20.1174C21.6102 19.8552 21.5094 19.6026 21.3273 19.414L17.6753 15.762C18.6633 14.5086 19.2784 13.0024 19.4504 11.4157C19.6223 9.82905 19.3441 8.22602 18.6475 6.79009C17.9509 5.35417 16.8642 4.14336 15.5116 3.29623C14.159 2.44911 12.5952 1.99989 10.9993 2V2ZM4.49928 10.5C4.49928 8.77609 5.1841 7.12279 6.40308 5.90381C7.62207 4.68482 9.27537 4 10.9993 4C12.7232 4 14.3765 4.68482 15.5955 5.90381C16.8145 7.12279 17.4993 8.77609 17.4993 10.5C17.4993 12.2239 16.8145 13.8772 15.5955 15.0962C14.3765 16.3152 12.7232 17 10.9993 17C9.27537 17 7.62207 16.3152 6.40308 15.0962C5.1841 13.8772 4.49928 12.2239 4.49928 10.5V10.5Z"
        fill="#444444"
      />
    </g>
    <defs>
      <clipPath id="clip0_2035_33348">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
  export default {
    name: "researchInsights",
    props: [],
    data: () => ({}),
    mounted() {},
    methods: {},
  };
</script>
